"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryLabel = void 0;

var _SideNav = require("@cjdev-internal/visual-stack/lib/components/SideNav");

var _reactRedux = require("react-redux");

var _actions = require("../../actions");

var CategoryLabel = (0, _reactRedux.connect)(function (state) {
  return {
    collapsed: (0, _actions.selectCollaspedStateFromSideNav)(state)
  };
}, null)(_SideNav.CategoryLabel);
exports.CategoryLabel = CategoryLabel;